import React from 'react';
import LabelValuePair from "../common/LabelValuePair";
import {AuditLog, AuditLogType, AuditLogTypeLabels} from "../../models/AuditLog";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';

import { dialogMedium } from "@/lib/dialogSize";

const ViewClientConfigurationChangeAuditLogDetailsModal: React.FC<{
  auditLog: AuditLog | null;
  open: boolean;
  onClose: () => void;
  organizationId: string;
}> = ({
  auditLog,
  open,
  onClose,
  organizationId
}) => {
  const generateDynamicLink = (
    entityId: string | null,
  ) => {
    if (entityId === null)
      return `/organization/${organizationId}/audit-logs`;

    return `/organization/${organizationId}/client-configuration/${entityId}`;
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      {auditLog ? (
        <DialogContent className={`${dialogMedium} overflow-hidden`}>
          <DialogHeader>
            <DialogTitle>
              { AuditLogTypeLabels[auditLog.eventType] }
            </DialogTitle>
          </DialogHeader>

          <Separator />

          {auditLog.additionalData ? (
            <>
              <span className="text-sm font-bold">
                Reason:
              </span>
              <span
                className="text-sm whitespace-pre-wrap break-words max-h-[15vh] overflow-y-auto pr-2"
              >
                {auditLog.additionalData}
              </span>
            </>
          ) : (
            <></>
          )}

          { auditLog.additionalData && (
            <Separator />
          )}

          <div className="flex flex-row gap-1">
            <span className="text-sm font-bold">
              Previous {auditLog.eventType === AuditLogType.DefaultClientConfigurationChange ? 'Default' : 'Active'} Configuration:
            </span>
            <span className="text-sm">
              <a href={generateDynamicLink(auditLog.oldValue)} className="text-primary underline-offset-4 hover:underline">
                {auditLog.oldValue}
              </a>
            </span>
          </div>

          <div className="flex flex-row gap-1">
            <span className="text-sm font-bold">
              New {auditLog.eventType === AuditLogType.DefaultClientConfigurationChange ? 'Default' : 'Active'} Configuration:
            </span>
            <span className="text-sm">
              <a href={generateDynamicLink(auditLog.newValue)} className="text-primary underline-offset-4 hover:underline">
                {auditLog.newValue}
              </a>
            </span>
          </div>

          <LabelValuePair
            label="Peroformed By"
            value={auditLog.performerEmailAddress}
          />

          <LabelValuePair
            label="Event Date"
            value={auditLog.eventDate}
          />

        </DialogContent>
      ) : (
        <div />
      )}
    </Dialog>
  );
};

export default ViewClientConfigurationChangeAuditLogDetailsModal;
